import React, { createContext, useState, ReactNode } from "react";

type Locale = "en";
type IntlContextType = [Locale, React.Dispatch<React.SetStateAction<Locale>>];

const intlContext = createContext<IntlContextType>(["en", () => {}]);

const IntlProviderWrapper = ({ children }: { children: ReactNode }) => {
  const [locale] = useState<Locale>("en");

  return (
    <intlContext.Provider value={[locale, () => {}]}>
      {children}
    </intlContext.Provider>
  );
};

export { intlContext, IntlProviderWrapper }; 